import React, { useEffect, useState } from 'react'
import numeral from 'numeral'
import _ from 'lodash'
import moment from 'moment'
import fileDownload from 'js-file-download'
import axios from 'axios'
import { nanoid } from 'nanoid'
import {
 Row, Col, DatePicker, Select, Modal,
} from 'antd'
import { useQuery, useLazyQuery } from '@apollo/react-hooks'
import {
 Div, H3, P, Loading, Icon, H4, Button, SmallText,
} from 'konsys-ui'
import { theme } from '../../styles/_variables'
import { GASSTATION_FUEL_SUMMARY_BY_YEAR, GASSTATION_FUEL_SUMMARY_BY_MONTH } from '../../constants/graphql/query'
import COMPANY_NAME, { ENUM } from '../../constants/company-name'
import { getAccessToken, getURL } from '../../utils/local-data-service'

const ReportEachDayModal = ({
  reportEachDayModal, setReportEachDayModal, month, company,
}) => {
  const [getData, { data, loading }] = useLazyQuery(GASSTATION_FUEL_SUMMARY_BY_MONTH)

  useEffect(() => {
    if (reportEachDayModal) {
      getData({
        variables: { month, companyType: company },
      })
    }
  }, [reportEachDayModal])
  return (
    <Modal
      width='650px'
      title={`ยอดเดือน ${moment(month).format('MMMM YYYY')} บริษัท ${COMPANY_NAME[company]}`}
      visible={reportEachDayModal}
      destroyOnClose={true}
      onCancel={() => {
        setReportEachDayModal(false)
      }}
      footer={null}
    >
      <Row style={{ margin: '24px 16px 0 24px', padding: '8px 32px', borderBottom: '1px solid #5278A0' }}>
        <Col span={1}></Col>
        <Col span={7}><P bold style={{ width: '100%' }} textAlign='center'>วันที่</P></Col>
        <Col span={8}><P bold style={{ width: '100%' }} textAlign='center'>ยอดที่ไม่ใช้ Fleet Card</P></Col>
        <Col span={8}><P bold style={{ width: '100%' }} textAlign='center'>ยอดที่ใช้ Fleet Card</P></Col>
      </Row>
      {
        data?.GasstationFuelSummaryByMonth?.data.map((report, idx) => (
          <Div key={nanoid()} padding='0 32px' margin='8px 0' bgColor={theme.color.offWhite} style={{ borderRadius: '5px 0 0 5px' }}>
            <Row type='flex' align='top' style={{ margin: '0' }}>
              <Col span={1}><P style={{ width: '100%' }} textAlign='center'>{idx + 1}.</P></Col>
              <Col span={7}><P style={{ width: '100%' }} textAlign='center'>{moment(report.date).format('DD MMMM YYYY')}</P></Col>
              <Col span={8}>
                <Div display='flex' flexDirection='column'>
                  <P style={{ width: '100%' }} textAlign='center'>{numeral(report.erpNonFleetCost).format('0,0.00')}</P>
                  <SmallText color={theme.color.coolGrey} textAlign='center'>({report.erpNonFleetFuelQuantity || 0} ลิตร)</SmallText>
                </Div>
              </Col>
              <Col span={8}>
                <Div display='flex' flexDirection='column'>
                  <P style={{ width: '100%' }} textAlign='center'>{numeral(report.erpFleetCost).format('0,0.00')}</P>
                  <SmallText color={theme.color.coolGrey} textAlign='center'>({report.erpFleetFuelQuantity || 0} ลิตร)</SmallText>
                </Div>
              </Col>
            </Row>
          </Div>
        ))
      }
    </Modal>
  )
}

const ExportFuelReportModal = ({
  exportFuelReportModal, setExportFuelReportModal,
}) => {
  const [loading, setLoading] = useState(false)
  const [range, setRange] = useState([])
  return (
    <Modal
      title='พิมพ์รายงานการเติมน้ำมัน'
      visible={exportFuelReportModal}
      destroyOnClose={true}
      onCancel={() => {
        setRange([])
        setExportFuelReportModal(false)
      }}
      onOk={() => {
        setLoading(true)
        axios({
          method: 'GET',
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
          },
          url: `${getURL().FILE_SERVER}/download/excel/fuelOrderLogByGasstation?${
            [
              `startDate=${moment(range[0]).format('YYYY-MM-DD')}`,
              `endDate=${moment(range[1]).format('YYYY-MM-DD')}`,
            ].join('&')
          }`,
        }).then((resp) => {
          fileDownload(resp.data, `รายงานการเติมน้ำมันวันที่ ${moment(range[0]).format('YYYY-MM-DD')} - ${moment(range[1]).format('YYYY-MM-DD')} .xlsx`)
          setLoading(false)
          setRange([])
          setExportFuelReportModal(false)
        })
      }}
      okButtonProps={{
        loading,
        disabled: loading || range.length < 2,
      }}
      cancelButtonProps={{
        disabled: loading,
      }}
    >
      <Div width='100%' display='flex' flexDirection='column' justifyContent='center'>
        <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='baseline'>
          <P>วันที่</P>
          <DatePicker.RangePicker
            format='DD/MM/YYYY'
            onChange={(e) => {
              setRange(e)
            }}
          />
        </Div>
      </Div>
    </Modal>
  )
}

export default () => {
  const [company, setCompany] = useState(ENUM.PADOONGRICH)
  const [year, setYear] = useState(moment())
  const [reportEachDayModal, setReportEachDayModal] = useState(false)
  const [month, setMonth] = useState(moment())
  const [exportFuelReportModal, setExportFuelReportModal] = useState(false)
  const { data, loading } = useQuery(GASSTATION_FUEL_SUMMARY_BY_YEAR, { variables: { year, companyType: company } })

  return (
    <Div display='flex' flexDirection='column'>
      <Row type='flex' justify='space-between' align='middle'>
        <H3 style={{ alignItems: 'flex-start' }} bold color={theme.color.primaryColor} margin='32px 0'>รายงานการเติมน้ำมันของรถบรรทุก</H3>
        <Div display='flex' margin='16px 0'>
          <Select
            style={{ width: 300, margin: '0 32px 0 0' }}
            onChange={e => setCompany(e)}
            value={company}
          >
            <Select.Option value={ENUM.PADOONGRICH}>{COMPANY_NAME.PADOONGRICH}</Select.Option>
            <Select.Option value={ENUM.TRANSPORT}>{COMPANY_NAME.TRANSPORT}</Select.Option>
          </Select>
          <Div>
            <P margin='0 8px 0 0'>ปี</P>
            <DatePicker mode='year' format='YYYY' style={{ width: 100 }} value={year} allowClear={false} onPanelChange={(e) => {
              setYear(e)
            }}/>
          </Div>
        </Div>
      </Row>
      <Div display='flex' flexDirection='row' alignItems='center' padding='0' margin='16px 0'>
        <Button
          text='พิมพ์รายงานการเติมน้ำมัน'
          onClick={() => {
            setExportFuelReportModal(true)
          }}
        />
      </Div>
      {
        loading
        ? <Loading center='true'/>
        : _.isEmpty(data?.GasstationFuelSummaryByYear?.data)
          ? <Div display='flex' width='100%' height='300px' justifyContent='center' alignItems='center' flexDirection='column'>
              <Icon margin='16px' fontSize='40px' icon='far fa-empty-set' color={theme.color.heather} />
              <H4 color={theme.color.heather} bold>ไม่พบรายงานการเติมน้ำมัน</H4>
            </Div>
          : <Div>
              <Row style={{ margin: '24px 16px 0 24px', padding: '0 32px' }}>
                <Col span={4}><P bold style={{ width: '100%' }} textAlign='center'>เดือน</P></Col>
                <Col span={8}><P bold style={{ width: '100%' }} textAlign='center'>ยอดที่ไม่ใช้ Fleet Card</P></Col>
                <Col span={8}><P bold style={{ width: '100%' }} textAlign='center'>ยอดที่ใช้ Fleet Card</P></Col>
              </Row>
              {
                data?.GasstationFuelSummaryByYear?.data.map((report, idx) => (
                  <Div key={Math.random() + idx} padding='16px 32px' margin='8px 0' bgColor={theme.color.offWhite} style={{ borderRadius: '5px 0 0 5px' }}>
                    <Row type='flex' align='middle' style={{ margin: '0 16px' }}>
                      <Col span={4}><P style={{ width: '100%' }} textAlign='center'>{moment(report.month).format('MMMM YYYY')}</P></Col>
                      <Col span={8}>
                        <P style={{ width: '100%' }} textAlign='center'>
                          {numeral(report.erpNonFleetCost).format('0,0.00')} <SmallText color={theme.color.coolGrey}>({report.erpNonFleetFuelQuantity || 0} ลิตร)</SmallText>
                        </P>
                      </Col>
                      <Col span={8}>
                        <P style={{ width: '100%' }} textAlign='center'>
                          {numeral(report.erpFleetCost).format('0,0.00')} <SmallText color={theme.color.coolGrey}>({report.erpFleetFuelQuantity || 0} ลิตร)</SmallText>
                        </P>
                      </Col>
                      <Col span={4}><Button small text='ดูยอดรายวัน' onClick={() => {
                        setMonth(moment(report.month))
                        setReportEachDayModal(true)
                      }}/></Col>
                    </Row>
                  </Div>
                ))
              }
            </Div>
      }
      <ReportEachDayModal
        reportEachDayModal={reportEachDayModal}
        setReportEachDayModal={setReportEachDayModal}
        month={month}
        company={company}
      />
      <ExportFuelReportModal
        exportFuelReportModal={exportFuelReportModal}
        setExportFuelReportModal={setExportFuelReportModal}
      />
    </Div>
  )
}
